// extracted by mini-css-extract-plugin
module.exports = {"tags":"FlowboxTags_tags__89I7I","button":"FlowboxTags_button__OXAAD","active":"FlowboxTags_active__Bds7x"};